import * as React from "react";
import { Button } from "./button";

export interface AppShellProps {
  user: { email: string };
  onLogout: () => void;
  appName?: string;
  centerSlot?: React.ReactNode;
  children: React.ReactNode;
}

export function AppShell({
  user,
  onLogout,
  appName = "Skyventures Ads",
  centerSlot,
  children,
}: AppShellProps) {
  return (
    <div className="min-h-screen flex flex-col bg-canvas">
      <header className="h-[52px] bg-surface border-b border-border flex items-center px-4 md:px-6 gap-3 flex-shrink-0">
        <div className="flex items-center gap-2">
          <div className="w-7 h-7 rounded-md bg-primary flex items-center justify-center">
            <img src="/logo.png" alt="" width={16} height={16} />
          </div>
          <span className="text-[13px] font-semibold">{appName}</span>
        </div>
        {centerSlot && (
          <>
            <div className="w-px h-4 bg-border-strong" />
            {centerSlot}
          </>
        )}
        <div className="ml-auto flex items-center gap-2.5">
          <span className="hidden sm:inline-flex items-center gap-1.5 text-[12px] text-ink-muted bg-canvas border border-border rounded-pill px-3 py-1 cursor-default max-w-[220px]">
            <svg
              width="13"
              height="13"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              className="flex-shrink-0"
            >
              <circle cx="12" cy="8" r="4" />
              <path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" />
            </svg>
            <span className="truncate">{user.email}</span>
          </span>
          <Button variant="text" size="md" onClick={onLogout}>
            로그아웃
          </Button>
        </div>
      </header>
      <main className="flex-1 overflow-y-auto py-6 md:py-8 px-4 md:px-8 lg:px-[5%] xl:px-[8%]">
        <div className="max-w-[1800px] mx-auto">{children}</div>
      </main>
    </div>
  );
}
